import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppAccessDeniedReason } from './app-access.service';

export interface AppAccessRuntimeState {
  blocked: boolean;
  reason?: AppAccessDeniedReason;
}

@Injectable({
  providedIn: 'root',
})
export class AppAccessRuntimeService {
  private readonly stateSubject = new BehaviorSubject<AppAccessRuntimeState>({
    blocked: false,
  });

  readonly state$: Observable<AppAccessRuntimeState> = this.stateSubject.asObservable();

  block(reason: AppAccessDeniedReason): void {
    this.stateSubject.next({ blocked: true, reason });
  }

  get snapshot(): AppAccessRuntimeState {
    return this.stateSubject.value;
  }
}
